import { apiPostCustomBody } from ".";
import { apiFetch, apiPost } from "@/utils";


function getMyArticles() { //Recupère les articles de l'adhérent (ceux qu'il a créé)
  return apiFetch('cms/articles/mine')
}

function getArticles() {
  return apiFetch('cms/articles');
}

function getArticle(articleId) {
  return apiFetch('cms/article?id=' + articleId);
}

function createArticle(titre, corps, isVisible, categoryId) { //Créer un article
  const bodyFormData = {
    "corps": corps
  }

  return apiPostCustomBody('cms/article/create?'
    + 'titre=' + titre
    + '&isVisible=' + isVisible
    + '&categoryId=' + categoryId, bodyFormData);
}

function deleteArticle(articleId) { //Supprimer un article
  return apiPost('cms/article/delete?articleId=' + articleId);
}


function updateArticle(articleId, titre, corps, isVisible, categoryId) { //Mise à jour d'article
  const bodyFormData = {
    "corps": corps
  }
  return apiPostCustomBody('cms/article/update?'
    + 'articleId=' + articleId
    + '&titre=' + titre
    + '&isVisible=' + isVisible
    + '&categoryId=' + categoryId, bodyFormData);
}

function createCategory(label) { //Créer une catégorie
  return apiPostCustomBody('cms/categ/create?'
    + 'label=' + label
  )
}
function deleteCategory(idCategorie) { //Supprime une catégorie
  return apiPostCustomBody('cms/categ/delete?'
    + 'idCategorie=' + idCategorie
  )
}
function updateCategory(idCategorie, label) { //Modifie une catégorie
  return apiPostCustomBody('cms/categ/update?'
    + 'idCategorie=' + idCategorie
    + '&label=' + label
  )
}

function getCategories() { //Récupère les catégories de l'adhérent
  return apiFetch('cms/categ')
}


////Export des méthodes
export default { getArticle, createArticle, getArticles, getCategories, deleteArticle, updateArticle, createCategory, deleteCategory, updateCategory, getMyArticles }
export { getArticle, createArticle, getArticles, getCategories, deleteArticle, updateArticle, createCategory, deleteCategory, updateCategory, getMyArticles }



// WEBPACK FOOTER //
// ./src/utils/cms.js